import { createAuth } from "@optimyl/auth";
import { getConfig } from "../config";
import { getTabSfEnv } from "../sfEnv";
import { Spinner } from "../components/Spinner";
import { EMPLOYER_CLIENT_ID, getUserManager } from "./userManager";

/**
 * The Employer Application's sign-in and sign-out (@optimyl/auth), bound to what is this app's own: its client, the tab's
 * Salesforce environment on every sign-in (`sf_env`, so the person signs in to the right org), its spinner and error
 * card, and the intake form as home.
 */
export const auth = createAuth({
  clientId: EMPLOYER_CLIENT_ID,
  getIdentityUrl: () => getConfig().IDENTITY_URL,
  isEnabled: () => Boolean(getConfig().AUTH_ENABLED),
  getUserManager,
  getSignInParams: (): Record<string, string> => {
    const sfEnv = getTabSfEnv();
    return sfEnv ? { sf_env: sfEnv } : {};
  },
  homePath: "/intake",
  busyView: <Spinner overlay />,
  errorView: (message) => (
    <div className="min-h-[100dvh] flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-sm w-full bg-white rounded-xl shadow-md p-8 text-center">
        <h1 className="text-lg font-semibold text-gray-900 mb-2">Authentication Error</h1>
        <p className="text-sm text-gray-600 mb-4">{message}</p>
        <a href="/" className="inline-block rounded-lg bg-brand-green px-6 py-3 text-white font-medium hover:bg-brand-green-hover transition-colors">
          Try Again
        </a>
      </div>
    </div>
  ),
});
